import React, { useEffect, useState } from "react";
import BkashForm from "./paymentGateway/BkashForm";
import { useTranslation } from "react-i18next";
import UddoktaPayForm from "./paymentGateway/UddoktaPayForm";
import SSLCommerz from "./paymentGateway/SSLCommerz";
import ShurjoPayForm from "./paymentGateway/ShurjoPayForm";

const ResellerPaymentGateway = ({ reseller }) => {
  const { t } = useTranslation();

  //---> Local State
  const [paymentGateway, setPaymentGateway] = useState("");

  useEffect(() => {
    const providers = reseller?.settings?.paymentGateway?.providers;
    if (!providers) return undefined;

    const activeProviders = Object.entries(providers)
      .filter(([_, value]) => value === true)
      .map(([key]) => key);
    if (activeProviders.length === 0) return undefined;

    setPaymentGateway(
      activeProviders[Math.floor(Math.random() * activeProviders.length)],
    );
  }, []);

  return (
    <div>
      <div className="paymentGateway fw-normal">
        <div className="form-check ">
          <input
            className="form-check-input"
            type="radio"
            id="bKash-payment"
            name="bKash"
            value={"bKash"}
            checked={paymentGateway === "bKash"}
            onChange={(e) => setPaymentGateway(e.target.value)}
          />
          <label className="form-check-label" for="bKash-payment">
            {t("bKash")}
          </label>
        </div>

        <div className="form-check ms-4">
          <input
            className="form-check-input"
            type="radio"
            id="uddoktapay-payment"
            name="uddoktapay"
            value={"uddoktapay"}
            checked={paymentGateway === "uddoktapay"}
            onChange={(e) => setPaymentGateway(e.target.value)}
          />
          <label className="form-check-label" for="uddoktapay-payment">
            {t("uddoktaPay")}
          </label>
        </div>

        <div className="form-check ms-4">
          <input
            className="form-check-input"
            type="radio"
            id="sslCommerz-payment"
            name="sslCommerz"
            value={"sslCommerz"}
            checked={paymentGateway === "sslCommerz"}
            onChange={(e) => setPaymentGateway(e.target.value)}
          />
          <label className="form-check-label" for="sslCommerz-payment">
            {t("sslCommerz")}
          </label>
        </div>

        <div className="form-check ms-4">
          <input
            className="form-check-input"
            type="radio"
            id="shurjoPay-payment"
            name="shurjoPay"
            value="shurjoPay"
            checked={paymentGateway === "shurjoPay"}
            onChange={(e) => setPaymentGateway(e.target.value)}
          />
          <label className="form-check-label" for="shurjoPay-payment">
            {t("shurjoPay")}
          </label>
        </div>
      </div>

      <div>
        {/* bkash payment page */}
        {paymentGateway === "bKash" && <BkashForm />}

        {/* uddoktaPays payment page */}
        {paymentGateway === "uddoktaPay" && <UddoktaPayForm />}

        {/* SSLCommerz payment page */}
        {paymentGateway === "sslCommerz" && <SSLCommerz />}

        {/* shurjoPay gateway form */}
        {paymentGateway === "shurjoPay" && <ShurjoPayForm />}
      </div>
    </div>
  );
};

export default ResellerPaymentGateway;
